"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@Const/common");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_1 = __importStar(require("react"));
const permissions_1 = require("@Const/permissions");
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const ExpandableItem_1 = __importDefault(require("../../Navigations/Sidebar/ExpandableItem"));
const WorksRegistrationSubNavigation = () => {
    const { rightsholderStore, uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const currentRightsholderId = rightsholderStore.currentRightsholderId;
    return (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [
            permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works,
            permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works,
            permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status,
        ] },
        react_1.default.createElement(ExpandableItem_1.default, { heading: 'Works Registration', icon: common_1.ICONS.writeIcon },
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works] },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.matchClaim.claim(currentRightsholderId) }, "Claiming Tool")),
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works] },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.createWork.root(currentRightsholderId) }, "Individual Registration Tool")),
            uiStore.isMobile ? null : (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works] },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.createWork.bulk.root(currentRightsholderId) }, "Bulk Registration Tool"))),
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works] },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.registrationDrafts.root(currentRightsholderId) }, "Registration Drafts")),
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status] },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.registrationHistory.root(currentRightsholderId) }, "Registration History")),
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works], orIsInternal: true },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.overclaim.root(rightsholderStore.currentRightsholderId) }, "Overclaims Tool")))));
};
exports.default = WorksRegistrationSubNavigation;
